import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A large cable drum (reel) on a pay-out stand: two timber flanges on a hub
// wound with heavy black cable, raised on a steel jack frame so it can spin out.
// A yard prop for laying power lines.
const FLANGE = "#9c7338";
const FLANGE_DK = "#6f5224";
const CABLE = "#3b3b44";
const HUB = "#4a4a4e";
const STAND = "#6c727a";

export const cableReel = defineModel({
  id: "cable-reel",
  batchId: "electric",
  name: "Cable reel",
  tags: ["prop", "electric", "power", "cable", "yard"],
  summary: "A timber cable drum on a pay-out stand.",
  footprint: 0.45,
  parts(): Part[] {
    const cy = 0.5; // hub height
    return [
      // Jack stand: two A-legs and an axle.
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.06), color: STAND, position: [-0.42, 0.28, -0.18], rotation: [0, 0, 0.2] },
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.06), color: STAND, position: [-0.42, 0.28, 0.18], rotation: [0, 0, 0.2] },
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.06), color: STAND, position: [0.42, 0.28, -0.18], rotation: [0, 0, -0.2] },
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.06), color: STAND, position: [0.42, 0.28, 0.18], rotation: [0, 0, -0.2] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 1.0, 8), color: "#4a4a4e", position: [0, cy, 0], rotation: [Math.PI / 2, 0, 0] },
      // Drum: two flanges, a hub and the wound cable.
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 0.06, 16), color: FLANGE, position: [0, cy, -0.18], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 0.06, 16), color: FLANGE, position: [0, cy, 0.18], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.16, 0.16, 0.3, 12), color: HUB, position: [0, cy, 0], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.3, 0.26, 16), color: CABLE, position: [0, cy, 0], rotation: [Math.PI / 2, 0, 0] },
      // Winding groove bands across the wound cable, so it reads as coiled.
      { geometry: new THREE.TorusGeometry(0.3, 0.016, 4, 18), color: "#2a2a30", position: [0, cy, -0.08] },
      { geometry: new THREE.TorusGeometry(0.3, 0.016, 4, 18), color: "#2a2a30", position: [0, cy, 0.0] },
      { geometry: new THREE.TorusGeometry(0.3, 0.016, 4, 18), color: "#2a2a30", position: [0, cy, 0.08] },
      // Flange rims.
      { geometry: new THREE.TorusGeometry(0.34, 0.012, 4, 16), color: FLANGE_DK, position: [0, cy, -0.2], rotation: [0, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.34, 0.012, 4, 16), color: FLANGE_DK, position: [0, cy, 0.2], rotation: [0, 0, 0] },
      // A loose tail of cable paying off the bottom.
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.3, 8), color: CABLE, position: [0.34, 0.18, 0.1] },
    ];
  },
  animations: [],
});
